<!DOCTYPE html>
<html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0">
  <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/font-awesome/3.1.0/css/font-awesome.min.css" />
</head>

<body>

  <div class="page view-details-courrier">
    <div class="d-flex justify-content-center">
      <h5 id="heading" class="text-light" style="font-size: 12px;">Default Signataire</h5>
      <button type="button" class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close"
        (click)="closeModal()">
        <i class="fas fa-times text-light" style="font-size: 1.5rem; "></i>
      </button>
    </div>
    <form #form="ngForm" novalidate id="msform">
      <div class="addButton  text-nowrap  float-right mt-3  mb-1 " *ngIf="autorized">
        <div class="button b2  w-auto text-light " (click)="onSubmit(form)" style=" background:#f3a14c !important; ">
          <i class="fas fa-solid fa-save float-left mt-1" style="font-size: 20px;"></i>
        </div>
      </div> <br>
      <div class="pcss4t pcss4t-effect-scale pcss4t-theme-1">
        <input type="radio" checked name="pcss4t" id="_tab2" class="_tab-content-2">
        <label for="_tab2">Liste signataires</label>
        <ul>
          <li class="_tab-content _tab-content-2 typography" style="overflow: auto;">
            <br>
            <fieldset>
              <div class="row d-flex justify-content-between">
                <div class="col-3">
                  <label for="tribunal">Tribunal</label>
                  <input type="text" id="tribunal" value="{{data.tribunal}}" readonly>
                </div>
                <div class="col-3">
                  <label for="tag_documents">Type de document</label>
                  <input type="text" id="tag_documents" value="{{data.tag_documents}}" readonly>
                </div>
              </div>

               <div class="col-md-12 mb-3 d-flex flex-column">
              <label class="fieldlabels" *ngIf="autorized">Signataires:
                <i id="addRowBtn_inf" class="fa fa-solid fa-plus text-success mt-3" style="font-size:22px; cursor:pointer" (click)="addRowBtn()"></i>
              </label>
              <table id="myTable" class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">Signataire</th>
                    <th scope="col">Fonction</th>
                    <th scope="col" [hidden]="true">Prenom & Nom</th>
                    <th scope="col" *ngIf="autorized">Email</th>

                    <th scope="col" *ngIf="autorized">Telephone</th>
                    <th scope="col" *ngIf="autorized">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of rows; let i = index">
                    <td>
                      <select [formControl]="row.firstNameControl" (change)="onPersonChange(i)" [disabled]="autorized ? false : true">
                        <option *ngFor="let person of list_personnes" [value]="person.name" [disabled]="autorized ? false : true" >{{ person.name }}</option>
                      </select>
                    </td>
                    <td><input type="text" [formControl]="row.professionControl" readonly/></td>
                    <td [hidden]="true">
                      <input [formControl]="row.NameControl" readonly />
                    </td>
                    <td>
                      <input [formControl]="row.lastNameControl" readonly *ngIf="autorized"/>
                    </td>
                    <td><input type="text" [formControl]="row.phoneControl" *ngIf="autorized"/></td>
                    <td class="d-flex justify-content-between" *ngIf="autorized">
                      <span class="">
                        <i class="fas fa-solid fa-trash delete-row text-danger" style="font-size:15px; cursor:pointer" (click)="deleteRow(i)"></i>
                      </span>

                      <span>
                        <i class="fas fa-solid fa-eye text-primary" style="cursor: pointer; font-size: 20px;" (click)="detailSignataire(row.firstNameControl.value)"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>










              <!-- <div class="row pb-2">
                <button class="btn btn-primary" (click)="addSignataire()">Ajouter</button>
              </div>
              <div class="form-card">
                <div class="d-flex justify-content-center align-items-center bg-dark text-light mb-4 p-2">
                  <span class="text-center align-middle">Liste des signataires</span>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Prenom</th>
                      <th scope="col">Email</th>
                      <th scope="col">Fonction</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let signataire of list_signataires; track signataire">
                      <th scope="row">{{signataire.nom_signataire}}</th>
                      <td>{{signataire.email}}</td>
                      <td>{{signataire.fonction}}</td>
                      <td (click)="detailSignataire(signataire.signataire)" style="cursor: pointer;">
                        <i class="fas fa-solid fa-eye text-primary" style="font-size: 20px;"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            </fieldset>
          </li>
        </ul>
      </div>
    </form>
  </div>

</body>

</html>
